import {setLocalStorage, delLocalStorage} from "../../utils/storage";
import setPromiseState from '../../utils/promiseState';
import actionTypes from './ActionTypes';
import initState from './InitState';

export default (state = initState, actions) => {
  switch (actions.type) {

    case actionTypes.SHOW_LOGIN:
      return {...state, isShow: true, isShowLogin: true, isShowResetPassword: false};

    case actionTypes.SHOW_RESET_PASSWORD:
      return {...state, isShow: true, isShowResetPassword: true, isShowLogin: false};

    case actionTypes.HIDE:
      return {...initState};
    /**
     * Register
     * */
    case actionTypes.REGISTER.pending:
      return {...state, promise: {...state.promise, register: {...setPromiseState(true, false, false)}}};
    case actionTypes.REGISTER.rejected:
      return {
        ...state,
        error: actions.data || {},
        promise: {...state.promise, register: {...setPromiseState(false, false, true)}}
      };
    case actionTypes.REGISTER.fulfilled:
      return {
        ...state,
        isShow: true,
        successRegister: true,
        registerEmail: actions.registerEmail,
        error: {},
        promise: {...state.promise, register: {...setPromiseState(false, true, false)}}
      };
    /**
     * Login
     * */
    case actionTypes.LOGIN.pending:
      return {...state, promise: {...state.promise, login: {...setPromiseState(true, false, false)}}};
    case actionTypes.LOGIN.rejected: {
      delLocalStorage('isAuthorised');
      return {
        ...state,
        error: actions.data || {},
        promise: {...state.promise, login: {...setPromiseState(false, false, true)}}
      };
    }
    case actionTypes.LOGIN.fulfilled: {
      setLocalStorage('isAuthorised', 'true');
      return {
        ...state,
        isShowLogin: false,
        isShow: false,
        isAuthorized: true,
        user: actions.data,
        error: {},
        promise: {...state.promise, login: {...setPromiseState(false, true, false)}}
      }
    }
    /**
     * Logout
     * */
    case actionTypes.LOGOUT.pending:
      return {...state, promise: {...state.promise, logout: {...setPromiseState(true, false, false)}}};
    case actionTypes.LOGOUT.rejected:
      return {
        ...state,
        error: actions.data || {},
        promise: {...state.promise, logout: {...setPromiseState(false, false, true)}}
      };
    case actionTypes.LOGOUT.fulfilled: {
      delLocalStorage('isAuthorised');
      return {...initState, promise: {...state.promise, logout: {...setPromiseState(false, true, false)}}};
    }
    /**
     * Get user data
     * */
    case actionTypes.GET_USER_INFO.pending:
      return {...state, promise: {...state.promise, getUserInfo: {...setPromiseState(true, false, false)}}};
    case actionTypes.GET_USER_INFO.rejected: {
      delLocalStorage('isAuthorised');
      return {
        ...state,
        error: actions.data || {},
        promise: {...state.promise, getUserInfo: {...setPromiseState(false, false, true)}}
      };
    }
    case actionTypes.GET_USER_INFO.fulfilled: {
      setLocalStorage('isAuthorised', 'true');
      return {
        ...state,
        isShowLogin: false,
        isShow: false,
        isAuthorized: true,
        user: actions.data || {},
        error: {},
        promise: {...state.promise, getUserInfo: {...setPromiseState(false, true, false)}}
      };
    }
    /**
     * Reset Password send Email
     * */
    case actionTypes.RESET_PASSWORD_SEND_EMAIL.pending:
      return {...state, promise: {...state.promise, resetPasswordSendEmail: {...setPromiseState(true, false, false)}}};
    case actionTypes.RESET_PASSWORD_SEND_EMAIL.rejected:
      return {
        ...state,
        error: actions.data || {},
        promise: {...state.promise, resetPasswordSendEmail: {...setPromiseState(false, false, true)}}
      };
    case actionTypes.RESET_PASSWORD_SEND_EMAIL.fulfilled: {
      return {
        ...state,
        isShowResetPassword: false,
        isShowSuccessResetPasswordSendEmail: true,
        promise: {...state.promise, resetPasswordSendEmail: {...setPromiseState(false, true, false)}}
      };
    }
    /**
     * Reset Password check hash
     * */
    case actionTypes.RESET_PASSWORD_CHECK_HASH.pending:
      return {...state, promise: {...state.promise, resetPasswordCheckHash: {...setPromiseState(true, false, false)}}};
    case actionTypes.RESET_PASSWORD_CHECK_HASH.rejected:
      return {
        ...state,
        error: actions.data || {},
        promise: {...state.promise, resetPasswordCheckHash: {...setPromiseState(false, false, true)}}
      };
    case actionTypes.RESET_PASSWORD_CHECK_HASH.fulfilled: {
      return {
        ...state,
        promise: {...state.promise, resetPasswordCheckHash: {...setPromiseState(false, true, false)}}
      };
    }

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/Auth/Reducer.js